import React from 'react';
import CommonPage from './CommonPage';
const Faq = () => {
  return (
    <CommonPage title="সাধারণ জিজ্ঞাসা">
      শীঘ্রই আমাদের সাধারণ জিজ্ঞাসাগুলো যুক্ত করা হবে।
    </CommonPage>
  );
};
export default Faq;
